import { swSettings } from "app/common/services/swSettings";
import type { IFilterHandlerReturnObj, IParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";

export const getMonthByMonthDurationRequiredChanges = (
    componentConfigId: string,
    selectedDuration: string,
    targetState: IRouterState,
    toParams: IParams,
): IFilterHandlerReturnObj => {
    const isAllowed = swSettings.allowedDuration(selectedDuration, componentConfigId);

    let monthlyPresetDuration;
    if (!isAllowed) {
        const defaultDatePickerPresetDuration = swSettings.components[componentConfigId]?.defaultParams?.duration;
        if (swSettings.isCustomDuration(selectedDuration)) {
            const [from, to] = selectedDuration.split("-");
            const isMonthly = from.split(".").length === 2 && to.split(".").length === 2;
            if (isMonthly) {
                const newMonthlyPresetDuration = `${to}-${to}`;
                if (!swSettings.allowedDuration(newMonthlyPresetDuration, componentConfigId)) {
                    if (defaultDatePickerPresetDuration !== toParams.duration) {
                        monthlyPresetDuration = defaultDatePickerPresetDuration;
                    }
                } else if (newMonthlyPresetDuration !== toParams.duration) {
                    monthlyPresetDuration = newMonthlyPresetDuration;
                }
            }
        } else if (defaultDatePickerPresetDuration !== toParams.duration) {
            monthlyPresetDuration = defaultDatePickerPresetDuration;
        }
    }

    const displayChangeIndicator =
        (!isAllowed || selectedDuration !== toParams.duration) && !toParams.isDurationChanged;
    const isChanged = !isAllowed;
    const shouldChangeToSelected = (selectedDuration !== toParams.duration && isAllowed) || !!monthlyPresetDuration;
    const value = isAllowed ? selectedDuration : (monthlyPresetDuration ?? toParams.duration);
    return {
        isAllowed,
        displayChangeIndicator,
        isChanged,
        shouldChangeToSelected,
        value,
    };
};
